import { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../store/ApplicationStore';

const BrandThemeHandler = ({ location, setBrandingText }) => {
    useEffect(() => {
        const isAppSubmit = location.pathname.indexOf('submit-application') !== -1;
        const brandingText = isAppSubmit ? 'ExpressLease' : 'MyAccount Manager';
     //   console.log(`%c Set Branding Text ${brandingText} `, 'background:orange; color:white; font-weight:bold');
        setBrandingText(brandingText);
    }, [location, setBrandingText]);

    return null; //no render required
};

export default connect(
    (state) => state.app,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(BrandThemeHandler);
